<template>
  <div :class="$style.icon">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
    >
      <path
        :class="$style.st0"
        d="M17.8,13H4.2c-0.6,0-1-0.4-1-1s0.4-1,1-1h13.6c0.6,0,1,0.4,1,1S18.3,13,17.8,13z"
      />
      <path
        :class="$style.st0"
        d="M17.8,17H4.2c-0.6,0-1-0.4-1-1c0-0.6,0.4-1,1-1h13.6c0.6,0,1,0.4,1,1C18.8,16.5,18.3,17,17.8,17z"
      />
      <path
        :class="$style.st0"
        d="M17.8,21H4.2c-0.6,0-1-0.4-1-1c0-0.6,0.4-1,1-1h13.7c0.6,0,1,0.4,1,1C18.8,20.5,18.4,21,17.8,21z"
      />
      <polygon
        :class="$style.st1"
        points="24.7,23.7 21,23.7 26,30 31,23.7 27.2,23.7 27.2,8.2 31,8.2 26,2 21,8.2 24.7,8.2"
      />
    </svg>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  name: 'FillArrowIcon'
}
</script>

<style lang="scss" module>
@import 'mpl-css/lib/assets/global/variables/colors';
@import 'mpl-css/lib/assets/global/functions/index';
.st0{fill: map-get($colors, 'grey');}
.st1{fill: map-get($colors, 'new-blue');}
.icon {
  width: rem(24);
  height: rem(24);
  svg {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    height: auto;
  }
}
</style>
